<template>
  <div
    :class="'d-flex' + (menu_toggle == true ? ' toggled' : '') + ' iff-mobile-wrapper d-lg-none'"
    id="wrapper"
  >
    <div class="sidebar-iff-color pb-5" id="sidebar-wrapper">
      <div v-if="configData.general.isEcommercePage" class="input-group my-3">
        <input
          type="text"
          v-model="searchData"
          placeholder="Busca aquí el producto de tu interés"
          maxlength="50"
          class="form-control search-control"
        />
        <template v-if="searchData == '' || searchData.length <= 2">
          <div class="input-group-append">
            <button disabled class="btn btn-al-celeste search-buttons" type="submit">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </template>
        <template v-else>
          <div class="input-group-append" v-on:click="toogle()">
            <router-link
              tag="button"
              type="submit"
              :key="'search' + searchData"
              :to="{
                path:
                  '/productos/0/1/' +
                  id_search_category +
                  '/' +
                  id_search_subcategory +
                  '/0/0/' +
                  searchData +
                  '',
              }"
              class="btn btn-al-celeste search-buttons"
            >
              <i class="fa fa-search"></i>
            </router-link>
          </div>
        </template>
      </div>
      <div class="list-group list-group-flush" v-on:click="toogle()">
        <a
          v-if="configData.general.isEcommercePage"
          class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
          data-toggle="modal"
          data-target="#exampleModal"
          ><i class="fa fa-caret-right"></i><span>Mi Carrito</span
          ><i class="fa fa-shopping-cart mr-1"></i>
          <span class="badge badge-danger" id="lblCartCount">
            {{ this.cartProducts.length }}
          </span>
        </a>
        <span class="modulo_titulo"><strong>ACCESOS RÁPIDOS</strong></span>
        <template v-for="section in section_list">
          <router-link
            :to="'/' + section.url_es"
            class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
            ><i class="fa fa-caret-right" aria-hidden="true"></i
            ><span>{{ section.name_sec_es }}</span></router-link
          >
        </template>
        <template v-if="configData.general.isLoggingAvailable">
          <template v-if="!logged">
            <span class="modulo_titulo"><strong>CUENTA</strong></span>
            <a
              class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
              data-toggle="modal"
              data-target="#myModal2"
              ><i class="fa fa-caret-right"></i><span>Iniciar Sesión</span></a
            >
          </template>
          <template v-else>
            <span class="modulo_titulo"
              ><strong>{{ 'Bienvenido, ' + user.name_client }}</strong></span
            >
            <router-link
              to="/perfil"
              class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
              ><i class="fa fa-caret-right"></i><span>Mi Cuenta</span></router-link
            >
            <router-link
              v-if="configData.general.isEcommercePage"
              to="/pedidos"
              class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
              ><i class="fa fa-caret-right"></i><span>Mis Pedidos</span></router-link
            >
            <router-link
              v-if="configData.general.isEcommercePage"
              to="/seguimiento"
              class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
              ><i class="fa fa-caret-right"></i><span>Seguimiento</span></router-link
            >
            <router-link
              v-if="configData.general.isEcommercePage"
              to="/carrito"
              class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
              ><i class="fa fa-caret-right"></i><span>Carrito de compras</span></router-link
            >
            <router-link
              to="/"
              class="list-group-item list-group-item-action bg-primary sidebar-iff-color-button"
              @click.native="loc_logout"
              ><i class="fa fa-caret-right"></i><span>Cerrar Sesión</span></router-link
            >
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSidebar',
  props: [
    'configData',
    'section_list',
    'search_subcategory',
    'user',
    'logged',
    'cartProducts',
    'id_search_category',
    'id_search_subcategory',
    'menu_toggle',
  ],
  data() {
    return {
      searchData: '',
    };
  },
  methods: {
    setSearch_subcategory(subcategory_id, subcategory_description, idcategoria) {
      this.$parent.setSearch_subcategory(subcategory_id, subcategory_description, idcategoria);
    },
    toogle() {
      this.$parent.toogle();
    },
    loc_logout() {
      this.$parent.loc_logout();
    },
  },
};
</script>
